<template>
    <audit-history :orgIdProp="orgContext || orgId"></audit-history>
</template>
<script>
import AuditHistory from '../CrossOrg/AuditHistory.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    'audit-history': AuditHistory
  },
  computed: {
    ...mapGetters('user', {
        orgContext: 'getOrgContext',
        orgId: 'getOrgId'
    })
  }
}
</script>